<template>
  <div id="app">
    <header class="fixed-top">
      <b-container>
        <b-row>
          <b-col><a href="#" @click="$router.replace({ name: 'start' })">
            <img id="top" src="./assets/logo.svg"  width="90" height="35" style="margin-top: 18px; margin-bottom: 18px; "/></a>
          </b-col>
        </b-row>
      </b-container>
    </header>
    <main role="main" class="content mt-5">
      <b-container class="mt-5">
        <b-row>
          <b-col>
            <router-view/>
          </b-col>
        </b-row>
      </b-container>
    </main>
    <ZMFooter class="footer p-0"></ZMFooter>
  </div>
</template>

<script>
import ZMFooter from '@/components/ZMFooter'
export default {
  name: 'App',
  components: { ZMFooter }
}
</script>
